export const LINKS = {
  github: "https://github.com/VirtualBlack2",
  email: "alieu.bojang@icloud.com",
  discord: "Virtual_Black",
  zerohour: "https://www.roblox.com/games/80481292697597/World-War-II",
  typingsurvival: "https://www.roblox.com/games/93071775781153/Typing-Survival",
  resume: "/assets/resume.pdf",
};

export const EXPERIENCE = [
  {
    org: "Steptoe LLP",
    role: "Information Technology Intern, AI & Data Innovation",
    place: "Washington, DC",
    time: "Jun 2026 — Aug 2026",
    points: [
      "Built and deployed a Microsoft Copilot agent to log contract records and search, filter, and retrieve licensing information from a centralized repository.",
      "Created an automated contract and licensing tracker centralizing vendor, application, budget, invoice, renewal, and expiration data.",
      "Developed Power Automate workflows for record intake and updates, reducing repetitive data entry.",
      "Cross-referenced contracts, POs, invoices, and budgets to flag duplicate, outdated, and incomplete records.",
    ],
  },
  {
    org: "Walgreens",
    role: "Shift Leader (2023 — Present) · Customer Service Associate (2022 — 2023)",
    place: "Fall River, MA",
    time: "2022 — Present",
    points: [
      "Promoted to shift leader; supervise daily operations, train team members, and coordinate task coverage.",
      "Resolve escalated customer concerns and troubleshoot operational issues in a fast-paced environment.",
    ],
  },
  {
    org: "Bridgewater State University",
    role: "B.S. Computer Science · Honors Program",
    place: "Bridgewater, MA",
    time: "Expected May 2027",
    points: ["Computer Science Club · Bartlett Beyond STEM Scholarship."],
  },
];

export const SKILLS = [
  { group: "Programming", items: ["Python", "Lua", "Java", "Dart"] },
  { group: "AI & Automation", items: ["Microsoft Copilot Studio", "Power Automate"] },
  { group: "Platforms & Tools", items: ["Microsoft 365", "SharePoint", "Excel", "Git", "Firebase", "Flutter", "Roblox Studio"] },
];

export const MARQUEE = ["10M+ plays on Roblox", "Copilot agents", "Discord bots", "WWII FPS — Zero Hour", "Power Automate", "Flutter & Firebase", "Bridgewater State '27"];
